/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AvailableLanguagesField,
  AvailableSoftwaresField,
  MailAddressField,
  NameField,
  PortfolioField,
  QuestionField,
  ReasonField,
  ResumeField,
  SelfPrField,
  SkillSheetField,
  SocialNetworkUrlsField,
  TelField,
  CompanyNameField,
  DepartmentNameField,
  RequestStartAtField,
  HowToFindField,
} from '~/form/components/organisms'
import validationRulesComposer from '~/form/libs/validationRulesComposer'
import type { Config } from '~/form/types'

const configs: Config[] = [
  {
    name: '氏名',
    component: NameField,
    props: {
      required: true,
    },
  },
  {
    name: 'メールアドレス',
    component: MailAddressField,
    props: {
      required: true,
    },
  },
  {
    name: '電話番号',
    component: TelField,
    props: {
      required: true,
    },
  },
  {
    name: '企業名・組織名・屋号',
    component: CompanyNameField,
    props: {
      required: true,
      placeholder: '株式会社TIMEMACHINE',
    },
  },
  {
    name: '所属部署名',
    component: DepartmentNameField,
    props: {
      placeholder: '人事部',
    },
  },
  {
    name: 'サクサク仕事探しを知ったキッカケ',
    component: HowToFindField,
    props: {},
  },
  {
    name: '掲載開始希望時期',
    component: RequestStartAtField,
    props: {
      required: true,
    },
  },
  {
    name: '質問事項',
    component: QuestionField,
    props: {
      placeholder:
        'サクサク仕事探しで求人を掲載するにあたり、質問事項や懸念事項を記入してください。',
    },
  },
]

export default configs

export const validators = validationRulesComposer(configs)
